import React, { Fragment, ReactNode } from 'react';

export const formatText = (text: string): ReactNode =>
    text.split(/\n/).map((content, index) => (
        <Fragment key={index}>
            {index !== 0 && <br />}
            {content}
        </Fragment>
    ));
